import styled from "styled-components";
import { Container } from "@material-ui/core";
import { Button } from "../../../../components";
import { Colors } from "../../../../constants";

export const ERPLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 16px;

  > span {
    text-align: center;
    font-size: 14px;
    color: #666;
  }
`;

export const ExportButtonERP = styled(Button)`
  min-width: auto;
  padding: 8px;
`;

export const DetailWrapper = styled.div`
  background-color: ${Colors.WHITE};
  box-sizing: border-box;
`;

export const PageWrapper = styled(Container)`
  padding: 24px;
  box-sizing: border-box;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 24px 0px;
`;

export const ActionButtonsTitle = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: ${Colors.SECONDARY_MEDIUM};
`;

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ExportButton = styled.span`
  color: ${Colors.TEXT_PRIMARY};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;
